import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions

async function modifyFolder(
  postal,
  interventiondone,
  payment_allowed,
  use_facture_mat,
  folder_type,
  ville,
  adresse,
  nom,
  prenom,
  num,
  comments,
  client_type,
  clientId,
  folderid,
  structure,
  marque,
  particulier,
  token,
  prefix
) {
  try {
    let start = new Date();
    // Define the endpoint URL
    const url = prefix + `folders/${folderid}`;

    // Extract clientId from the Firestore document reference

    // Define the request body
    const body = {
      postal: postal,
      ville: ville,
      adresse: adresse,
      comments: comments,
      nom: nom,
      prenom: prenom,
      folder_type: folder_type,
      num: num,
      client_type: client_type,
      structure_type: structure,
      client: clientId,
      particulier: particulier,
      folderid: folderid,
      interventiondone: interventiondone ?? false,
      marque: marque,
      payment_allowed: payment_allowed ?? false,
      use_facture_mat: use_facture_mat ?? false,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    // Make the PUT request
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Get the current user reference using Firebase Authentication
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    // Get the Firestore reference for the current user
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    // Add log document (assuming you have an `addLogDocument` function)
    await addLogDocument(
      url,
      prefix,
      userRef, // Pass only the user ID
      org_id, // Organization reference from Firestore
      response.status.toString(),
      folderid,
      "",
      JSON.stringify(body),
      await response.text(), // Get the response body as text
      "PUT",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return "Folder modified successfully";
    } else {
      console.error(`Failed to modify folder: ${response.status}`);
      return `Failed to modify folder: ${response.status}`;
    }
  } catch (error) {
    console.error("Exception occurred while modifying folder:", error);
    return `Exception occurred: ${error.message}`;
  }
}

export default modifyFolder;
